import { useEffect, useRef, useState } from "react";
import {
  bankAccountOptions,
  homologateBankNameAccount,
  typeBankAccountOptions,
} from "../../utils/options_selects";
import { sanitizarInputNumerico } from "../../utils/validateData";
import FilterableSelect from "../new_components/FilterableSelect";
import StepInput from "../new_components/StepInput";

export function FormBankAccountToEdit({
  _state = {
    bankAccount: "",
    typeBankAccount: "",
    accountNumber: "",
    parent: false,
  },
  setState,
  errorField,
  accountToEdit,
}) {
  const [, setOptionsTypesAccount] = useState([]);
  const [newBankAccount, setNewBankAccount] = useState([]);
  const stateRef = useRef(_state);
  stateRef.current = _state;

  const handleChangeSelect = (e) => {
    if (e.target.name === "accountNumber") {
      const sanitizedValue = sanitizarInputNumerico(e.target.value);
      e.target.value = sanitizedValue;
    }
    const { name, value } = e.target;
    setState({ ..._state, [name]: value });
  };

  useEffect(() => {
    // let modifiedOptionsBanks = bankAccountOptions.filter(
    //   (ba) => ba.label !== accountToEdit?.bankAccount && ba.value !== 0,
    // );
    // setOptionsBankAccounts(modifiedOptionsBanks);
    // setBankSelected(handleFilterBankToEdit());

    let modifiedOptionsTypeAccount = typeBankAccountOptions.filter(
      (type) =>
        type.label !== accountToEdit?.typeBankAccount && type.value !== 0,
    );
    setOptionsTypesAccount(modifiedOptionsTypeAccount);
    // setTypeAccSelected(handleFilterTypesAccountToEdit);
    setState({
      ...stateRef.current,
      accountNumber: accountToEdit?.accountNumber,
      parent: accountToEdit?.parent,
      typeBankAccount: accountToEdit?.typeBankAccount,
      bankAccount: homologateBankNameAccount(
        accountToEdit?.bankAccount,
        "value",
      ),
      id: accountToEdit?.id,
    });
    // '_state' is read via stateRef (not as a dependency): this effect calls setState(...) with a
    // spread of '_state' itself, which would produce a new object reference every run even when
    // the resulting content is identical, re-triggering this effect indefinitely if '_state' were
    // a dependency. 'setState' is the stable setter returned by useState (see BancoPage.js).
  }, [
    errorField,
    setState,
    accountToEdit?.accountNumber,
    accountToEdit?.parent,
    accountToEdit?.typeBankAccount,
    accountToEdit?.bankAccount,
    accountToEdit?.id,
  ]);

  useEffect(() => {
    setNewBankAccount(bankAccountOptions.filter((b) => b.value !== 9));
  }, []);

  return (
    <form action="#" method="POST">
      <div className="mt-3">
        <div>
          <div className="mt-4">
            <div>
              <FilterableSelect
                options={newBankAccount.map((banck) => ({
                  label: banck.label,
                  value: banck.value,
                  icon: banck.icon,
                }))}
                label={"Banco"}
                value={_state.bankAccount}
                onChange={handleChangeSelect}
                name="bankAccount"
                placeholder="Selecciona tu banco"
                error={errorField.bankAccount}
                required
              />
            </div>
            {errorField.bankAccount && (
              <span
                className="text-sm"
                style={{ color: "#fc3e58", fontStyle: "italic", paddingTop: 0 }}
              >
                {errorField.bankAccount}
              </span>
            )}
          </div>
          <div className=" mt-4">
            <div>
              <FilterableSelect
                options={typeBankAccountOptions.map((type) => ({
                  label: type.label,
                  value: type.value,
                }))}
                label={"Tipo de cuenta"}
                value={_state.typeBankAccount}
                onChange={handleChangeSelect}
                name="typeBankAccount"
                placeholder="Selecciona el tipo de cuenta"
                error={errorField.typeBankAccount}
                required
              />
            </div>
            {errorField.typeBankAccount && (
              <span
                className="text-sm"
                style={{
                  color: "#fc3e58",
                  fontStyle: "italic",
                  textAlign: "left",
                  paddingTop: 0,
                }}
              >
                {errorField.typeBankAccount}
              </span>
            )}
          </div>

          <div className="mt-4">
            <div>
              <StepInput
                name="accountNumber"
                value={_state.accountNumber}
                label={"Número de cuenta"}
                onChange={handleChangeSelect}
                error={errorField.accountNumber}
                required
                placeholder="49000000564"
                autoFocus={true}
                type="number"
                maxLength={15}
              />
            </div>

            {errorField.accountNumber && (
              <span
                className="text-sm"
                style={{
                  color: "#fc3e58",
                  fontStyle: "italic",
                  paddingBottom: 0,
                }}
              >
                {errorField.accountNumber ?? ""}
              </span>
            )}
          </div>
        </div>
      </div>
    </form>
  );
}
